import { Box, Button, Typography } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import AnimationFadeIn from "@components/AnimationFadeIn";

export default function CatalogLODetail() {
  const { t } = useTranslation("catalog-v2");
  const navigate = useNavigate();
  const { id: corporateId = "" } = useParams();

  return (
    <AnimationFadeIn>
      <Button
        variant="text"
        startIcon={<ArrowLeft size={16} />}
        onClick={() => navigate(`/v2/corporate/${corporateId}/detail/catalog`)}
        sx={{ mb: 2 }}
      >
        {t("actions.back")}
      </Button>
      <Box>
        <Typography variant="h4" lineHeight={1} gutterBottom>
          {t("detail.title")}
        </Typography>
        <Typography color="text.primary">{t("detail.subtitle")}</Typography>
      </Box>
    </AnimationFadeIn>
  );
}
